import Vue from "vue";
import Vuex from 'vuex';
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueCropper from 'vue-cropper'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "./bus";
import store from './store';

Vue.prototype.$snackbar = {};
Vue.prototype.$dialog = {};
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  VueCropper,
  Vuex,
  store,
  render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    console.log("**進入此頁面需驗證**");
    const auth = getAuth();
    let authFlag = false;
    onAuthStateChanged(auth, (user) => {
      if (!authFlag) {
        authFlag = true;
        if (user) {
          const uid = user.uid;
          console.log("已登入", uid);
          next();
        } else {
          console.log("已登出");
          next({
            path: "/login",
          });
        }
      }
    });
  } else {
    next();
  }
});
